import { jsx as _jsx } from "react/jsx-runtime";
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
import { useTheme } from '@mui/material/styles';
// Importing store
import { usePlayerStore } from '../../../store/player.store';
// Importing 3rd party dependencies
import { Fragment, useState } from 'react';
// Importing 3rd party components
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// ----------------------------------------------------------------------
export const Captions = (props) => {
    var _a, _b;
    // Adding hooks
    const theme = useTheme();
    // Adding data handler
    const { captions, player, playing } = usePlayerStore(useShallow((state) => ({
        captions: state.captions,
        player: state.player,
        playing: state.playing,
    })));
    // Defining state for caption
    const [caption, setCaption] = useState(undefined);
    // Getting tracks from player
    const tracks = ((_a = player.current) === null || _a === void 0 ? void 0 : _a.getInternalPlayer()) && ((_b = player.current) === null || _b === void 0 ? void 0 : _b.getInternalPlayer().textTracks);
    // Checking if captions are available
    if (captions !== 'undefined' && tracks.length > 0) {
        // Getting track by id
        const track = tracks.getTrackById(captions);
        if (track) {
            // Enabling track
            track.mode = 'hidden';
            // Adding event listener to route caption text to component
            track.addEventListener('cuechange', () => {
                if (track.activeCues.length > 0) {
                    setCaption(track.activeCues[0].text);
                }
                else {
                    setCaption(undefined);
                }
            });
        }
    }
    return (_jsx(Fragment, { children: caption && captions !== 'undefined' && playing && (_jsx(Stack, { sx: {
                alignItems: 'center',
                backgroundColor: 'rgba(42, 54, 132, 0.50)',
                backdropFilter: 'blur(5px)',
                borderRadius: 2,
                maxWidth: '75%',
                p: 2,
            }, children: _jsx(Typography, { color: "white", variant: "h6", sx: { fontSize: { xs: '0.75rem', sm: '0.875rem', md: '1rem' } }, children: caption }) })) }));
};
